import { render, staticRenderFns } from "./ShowDoctorData.vue?vue&type=template&id=ce2ebc80&scoped=true"
import script from "./ShowDoctorData.vue?vue&type=script&lang=js"
export * from "./ShowDoctorData.vue?vue&type=script&lang=js"
import style0 from "./ShowDoctorData.vue?vue&type=style&index=0&id=ce2ebc80&prod&scoped=true&lang=css"
import style1 from "./ShowDoctorData.vue?vue&type=style&index=1&id=ce2ebc80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2ebc80",
  null
  
)

export default component.exports